

import { useState } from "react";
import React from 'react'
import { Link } from "react-router-dom";

export default function TrainingServiceWork({ data }) {

  const [activeIndex, setActiveIndex] = useState(0);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };


  return (
    <>
      <div className="service-faq">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12 col-lg-6">
              <div className="heading-content">
                <h3 className="heading" dangerouslySetInnerHTML={{ __html: data?.heading }} />
              </div>
              <div className="card">
                <div className="col2">
                  <div className="freqAskQuertion">
                    {data.faqs.map((faq, index) => (
                      <div className={`item ${activeIndex === index ? "active-items" : ""}`} key={index} >
                        <div className={`faq-title ${activeIndex === index ? "active" : ""}`} onClick={() => toggleFaq(index)}   >
                          <div className="faq-inner">  {faq.question}    </div>
                          <span className="arrow">{activeIndex === index ? "−" : "+"} </span>
                        </div>
                        <div className="faq-content" style={{ display: activeIndex === index ? "block" : "none" }}  >
                          <div className="content">
                            {typeof faq.answer === "string" ? (
                              <p>{faq.answer}</p>
                            ) : (
                              faq.answer
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-6">
              <img src={data.image} alt="FAQ Image" className="img-responsive" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}



